import React from 'react';
import Images from '../assets/AllImages';

const mainData = [
    [
        {
            img: Images.Package1,
            title: "Elite Athlete Training Package",
            desc: "Designed for professional athletes, this all-inclusive offer provides high-performance swim sessions, tailored meals, and premium accommodation for peak conditioning.",
        },
        {
            img: Images.Package2,
            title: "Family Fitness Escape",
            desc: "A perfect weekend getaway combining recreational swimming, family-friendly activities, nutritious dining, and cozy rooms — all in one vibrant space.",
        },
        {
            img: Images.Package3,
            title: "International Club Residency",
            desc: "Ideal for visiting clubs, this long-stay package includes full access to training facilities, scheduled practice times, dietary programs, and on-site lodging.",
        },
    ],
    [
        {
            img: Images.Package4,
            title: "Junior Swimmers Bootcamp",
            desc: "Focused on youth development, this seasonal package blends technical training, group learning, balanced nutrition, and fun downtime for young talents.",
        },
        {
            img: Images.Package5,
            title: "Weekend Wellness Retreat",
            desc: "Tailored for rest and rejuvenation, this short-stay package includes spa access, light aquatic workouts, therapeutic meals, and peaceful overnight stays.",
        },
        {
            img: Images.Package6,
            title: "Seasonal Prep Camp",
            desc: "For athletes preparing for national or international competitions, this offer includes structured swim practices, recovery treatments, and energy-rich cuisine.",
        },
    ],
    [
        {
            img: Images.Package7,
            title: "Coach & Team Intensive",
            desc: "Aimed at coaching teams and staff, this group package includes meeting spaces, analysis sessions, specialized workshops, and performance-focused dining.",
        },
        {
            img: Images.Package8,
            title: "Family Summer Stay & Swim",
            desc: "Enjoy a family holiday that balances relaxation and activity: pool access for all ages, educational swim lessons, healthy menus, and modern accommodation.",
        },
        {
            img: Images.Package9,
            desc: "Created for those recovering from injury or fatigue, this program combines hydrotherapy, tailored fitness, healthy meals, and a calm lodging experience.",
            title: "Rehab & Recovery Week",
        },
    ],
    [
        {
            img: Images.Package10,
            title: "Swim & Study Residential",
            desc: "Perfect for young student-athletes, this extended package blends daily training with guided study hours, personalized coaching, and academic-friendly environments.",
        },
        {
            img: Images.Package11,
            title: "Championship Week Residency",
            desc: "Available during competition periods, this offer secures accommodation, warm-up access, nutrition planning, and pre-race support for teams and individuals.",
        },
        {
            img: Images.Package12,
            title: "Club Exchange Program",
            desc: "In partnership with international clubs, this cultural and athletic exchange package includes dual training schedules, shared meals, and team-building stays.",
        },
    ],
];


const PackageCard = ({ img, title, desc, date }) => {
    return (
        <div className="col-12 col-md-4 col-sm-6">
            <div className="border border-primary rounded p-2 h-100 text-md-center">
                <img src={img} alt={title} className="w-100 mb-4" style={{ height: "180px", objectFit: "cover" }} />
                <h5 className='text-primary fw-bold'>{title}</h5>
                <p>{desc}</p>
                <span className="text-muted">{date || "17.06.2025"}</span>
            </div>
        </div>
    );
};


const PACKEDGES = () => {
    return (
        <>
            <main>
                <div className="container-fluid bg-primary py-3 py-md-0">
                    <div className="row align-items-center">
                        <div className="col-12 col-md-6 px-5">
                            <h5 className='text-white fw-bold'>PACKAGES</h5>
                        </div>
                        <div className="col-12 col-md-6 px-5 d-none d-sm-block">
                            <img src={Images.Vactor2} alt="" className='w-50 float-end' />
                        </div>
                    </div>
                </div>
            </main>

            <div className="container my-4">
                {mainData.map((group, idx) => (
                    <div className="row g-3 mb-4" key={idx}>
                        {group.map((item, i) => (
                            <PackageCard key={i} {...item} />
                        ))}
                    </div>
                ))}
            </div>
        </>
    );
};

export default PACKEDGES;
